<template>
  <canvas ref="canvas" v-bind="$attrs" />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { decode } from "blurhash";

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<{
  hash: string;
  width?: number;
  height?: number;
}>(), {
  width: 32,
  height: 32,
});

const canvas = ref<HTMLCanvasElement | null>(null);

watch(
  [() => props.hash, canvas] as const,
  ([hash, cvs]) => {
    if (!hash || !cvs) return;
    cvs.width = props.width;
    cvs.height = props.height;
    try {
      const pixels = decode(hash, props.width, props.height);
      const ctx = cvs.getContext("2d");
      if (!ctx) return;
      const imageData = ctx.createImageData(props.width, props.height);
      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);
    } catch {
      // Ignore invalid blurhashes
    }
  },
  { immediate: true },
);
</script>
